<div mat-dialog-title>
  <div class="title-content">
    <h1 class="title-modal">{{ dataModal.title }}</h1>
    <button [mat-dialog-close]="false" class="one-icon-close-material-v2 close-icon"></button>
  </div>
  <mat-progress-bar mode="indeterminate" class="rp-loading-bar" [class.hidden]="!loading"></mat-progress-bar>
</div>

<div class="content-info" mat-dialog-content>
  <p [innerHTML]="dataModal.message"></p>
  <form #myForm="ngForm" [formGroup]="formDelivery" (ngSubmit)="confirm()" id="formDelivery">
    <div class="content-inputs">
      <div class="field-content">
        <one-select
          #selectComponent
          (selectionChanged)="formDelivery.patchValue({ select_id: $event.id }); setMaxValue($event.maxValue)"
          [dataSource]="selectList"
          label="Select {{ dataModal.titleEntity }}"
        >
        </one-select>
      </div>
      <div class="field-content">
        <one-input autocomplete="off" formControlName="units" type="number" label="Units"></one-input>
      </div>
    </div>
    <div class="content-error">
      <span
        *ngIf="
          (formDelivery.get('units').hasError('required') ||
            formDelivery.get('units').hasError('max') ||
            formDelivery.get('units').hasError('min') ||
            formDelivery.get('select_id').hasError('required')) &&
          myForm.submitted
        "
        class="error-message"
      >
        {{ getErrorMessage() }}
      </span>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <div class="content-buttons">
    <button class="rp-button rp-primary rp-outlined rp-small" [matDialogClose]="false">Cancel</button>
    <button form="formDelivery" type="submit" class="rp-button rp-filled rp-primary rp-small">Confirm</button>
  </div>
</div>
